import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  tableCell: {
    padding: "4px 12px",
    fontSize: "0.8125rem",
  },
  topBarContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "16px",
  },
  tableRow: {
    height: "50px",
    cursor: "pointer",
    transition: "background-color 0.2 linear",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.07)",
      transition: "background-color 0.2 linear",
    },
  },
  dataExporter: {
    marginLeft: "16px",
    paddingLeft: "16px",
    borderLeft: "1px solid #e0e0e0",
  },
  filtersContainer: {
    width: "100%",
  },
  ResponsivePagination: {
    textAlign: "center" as "center",
    marginBottom: "32px",
    "&>button": {
      marginLeft: "8px",
      marginRight: "8px",
    },
  },
  "@global": {
    "tbody tr:nth-child(odd)": {
      backgroundColor: "#fafafa",
    },
  },
  historyButton: {
    color: grey[400],
  },
}));
